import useWaDisasterRepo from '../repository/WaDisasterRepo';
import { useWaDisasterStore } from '../store/WaRegionAndDisasterStore';

function useWaRegionService() {
  const { getLatestDisastersRequest } = useWaDisasterRepo();
  const { setSelectedDisaster } = useWaDisasterStore();

  const getDisasters = async () => {
    try {
      const disaster = await getLatestDisastersRequest();

      if (disaster) {
        setSelectedDisaster(disaster);
      } else {
        setSelectedDisaster(null);
      }
    } catch (error) {
      console.log('Failed to get disasters', error);
    }
  };

  return { getDisasters };
}

export default useWaRegionService;
